export default function Button({ children, color }) {
  const buttonClasses = `px-4 py-2 md:py-3 font-semibold bg-light-purple text-white rounded-sm hover:bg-light-orange transition-all duration-300`;
  return <button className={buttonClasses}>{children}</button>;
}
